module.exports = __webpack_public_path__ + "static/media/wings wireframe.5eb12c01.png";